import { jsx } from "react/jsx-runtime";
import { Button } from "@mui/material";
import { validateTidalLicense } from "@workwave-tidal/core/base";
function FormActionButton(props) {
  const {
    label,
    testId = "form-action-button-root",
    onClick,
    disabled,
    color = "primary",
    variant = "text",
    className = ""
  } = props;
  return /* @__PURE__ */ jsx(
    Button,
    {
      size: "small",
      color,
      variant,
      onClick,
      disabled,
      className,
      "data-testid": testId,
      children: label
    }
  );
}
validateTidalLicense();
export {
  FormActionButton
};
//# sourceMappingURL=FormActionButton.js.map
